import React from 'react';
import { css } from 'emotion';
import { textSans } from '@guardian/src-foundations/typography';
import { neutral } from '@guardian/src-foundations/palette';
const fieldLabelStyles = css `
    ${textSans.medium({ fontWeight: 'bold' })}
`;
const fieldDescription = css `
    ${textSans.medium()}
`;
const optionalTextStyles = css `
    ${textSans.small({ fontStyle: 'italic' })}
    color: ${neutral[46]};
    padding-left: 5px;
`;
export const FieldLabel = ({ formField }) => (React.createElement("label", { className: fieldLabelStyles, htmlFor: formField.name },
    formField.label,
    !formField.required && (React.createElement("span", { className: optionalTextStyles }, "Optional")),
    formField.description && (React.createElement("div", null,
        React.createElement("span", { className: fieldDescription }, `(${formField.description})`)))));
